import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import 'react-datepicker/dist/react-datepicker.css';
import UnitsSelectionDropdown from "src/components/Common/UI/UnitsSelectionDropdown/UnitsSelectionDropdown";


const FallsUnderForm = ({initialValues, onSubmit }: FallsUnderFormProps) => {
  const { t } = useTranslation();


  const validationSchema= Yup.object({
    unitID: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ errors, touched, isSubmitting, values, getFieldProps }) => (
        <Form>
          <Container fluid className="p-0">
            <Row>

             <UnitsSelectionDropdown errors={errors} touched={touched} />

             <Col xs={6}></Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Σχόλια")}
                </label>
                <Field
                  type="text"
                  name="comments"
                  field="comments"
                  className="form-control"
                  as="textarea"
                />
                <div className="text-danger">
                  {errors.comments && touched.comments && (
                    <div>{errors.comments}</div>
                  )}
                </div>
              </Col>
          
            </Row>
          </Container>

          <div className="mb-3">
            <Button
              type="submit"
              size="sm"
              styletype="primary"
              disabled={isSubmitting}
            >
              {t("Αποθήκευση")}
            </Button>
          </div>
        </Form>
    )}
    </Formik>
)
}

export default FallsUnderForm;

type FallsUnderFormProps =
| {
    initialValues: IUpdateFallsUnderForm;
    onSubmit: (
      values: IUpdateFallsUnderForm,
      formikHelpers: FormikHelpers<IUpdateFallsUnderForm>
    ) => void;
  }
